import React from "react";
import "../App.css";
import { connect } from "react-redux";
import {
  getPendingTask,
  getPendingTaskLineItems,
} from "../Actions/ShipViewAPI";
import { UploadDocument } from "../Actions/CommonAPI";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import Moment from "moment";
import { DownloadDocument } from "../Actions/CommonAPI";
import API from "../helpers/api";
import swal from "sweetalert";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import moment from "moment";

class StaffPOUpdate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      attachment: "",
      file: "",
      valueError: false,
      Material: {
        shipId: 0,
        poLineItemId: 0,
        purchaseOrderId: 0,
        locationUsed: "",
        locationRemoved: "",
        quantityUsed: "",
        quantityRemoved: "",
        attachmentName: "",
        attachmentGuid: "",
        designatedPersonRank: "",
        designatedPersonName: "",
        comments: "",
        modifiedBy: "",
        equipment: "",
        deck: "",
        installationDate: ""
      },
      isDateOpen: false,
      attachmentDetail: {},
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.UpdateMaterial = this.UpdateMaterial.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { dispatch, TaskDetails, attachmentDetail } = nextProps;
    if (TaskDetails !== undefined && TaskDetails !== null) {
      prevState.Material.shipId = TaskDetails.shipId;
      prevState.Material.purchaseOrderId = TaskDetails.purchaseOrderId;
      prevState.Material.poLineItemId = TaskDetails.poLineItemId;
    }
    if (attachmentDetail) {
      prevState.Material.attachmentName = attachmentDetail.FileName;
      prevState.Material.attachmentGuid = attachmentDetail.Guid;
      prevState.file = "";
    }
  }

  hideSidePanel = () => {
    this.props.dispatch({ type: "ShowStaffPendingTaskPanel", data: false });
    // this.props.history.push("/Home/Ship/Staff/Tasks");
    this.props.history.goBack();
  };

  handleInputChange(e) {
    let nodeName = e.target.name;
    if (nodeName === "attachment") {
      this.state.attachment = e.target.files[0].name;
      this.state.file = e.target.files[0];
      this.setState({});
      this.props.dispatch(UploadDocument(e.target.files[0]));
    } else {
      this.state.Material[nodeName] = e.target.value;
      this.setState({});
    }
  }
  handleInputChangeDate(value) {
    let newvalue = value
      ? moment(value).format("YYYY-MM-DD h:mm A")  // Uppercase A for AM/PM
      : '';
    console.log(moment(newvalue).format("YYYY-MM-DDTHH:mm:ss"));
    this.state.Material.installationDate = newvalue;
    this.setState({ isDateOpen: false });
  }

  ClearInput() {
    this.setState({ file: "", attachment: "" });
  }

  handleValidate = () => {
    const { Material } = this.state;
    let error = false;
    if (Material.locationUsed.trim() == "") {
      error = true;
      this.setState({ valueError: true })
    }
    if (Material.quantityUsed.trim() == "") {
      error = true;
      this.setState({ valueError: true })
    }
    if (Material.locationRemoved.trim() == "") {
      error = true;
      this.setState({ valueError: true })
    }
    if (Material.quantityRemoved.trim() == "") {
      error = true;
      this.setState({ valueError: true })
    }
    if (Material.equipment.trim() == "") {
      error = true;
      this.setState({ valueError: true })
    }
    if (Material.deck.trim() == "") {
      error = true;
      this.setState({ valueError: true })
    }
    if (Material.installationDate.trim() == "") {
      error = true;
      this.setState({ valueError: true })
    }
    if (Material.designatedPersonName.trim() == "") {
      error = true;
      this.setState({ valueError: true })
    }
    if (Material.designatedPersonRank.trim() == "") {
      error = true;
      this.setState({ valueError: true })
    }
    // if (this.state.attachment == "") {
    //   error = true;
    //   this.setState({ valueError: true })
    // }
    return error;
  }

  UpdateMaterial() {
    const { dispatch, shipDetail, EditAllPO, history } = this.props;
    const { designatedPersonName, designatedPersonRank } = this.state.Material;
    const { Material } = this.state.Material;
    // let warning = [];
    // if (Material.locationUsed.trim() == "") {
    //   warning.push("Location Used");
    // }
    // if (Material.quantityUsed.trim() == "") {
    //   warning.push("Quantity Used");
    // }
    // if (designatedPersonName === "") {
    //   warning.push("Designated Person Name");
    // }
    // if (designatedPersonRank === "") {
    //   warning.push("Designated Person Rank");
    // }

    if (!this.handleValidate()) {
      // swal("Error!", "Filled all mandatory fields", "warning");
      if (EditAllPO === false) {
        let data = {
          ...this.state.Material,
          installationDate: moment(this.state.Material.installationDate).format("YYYY-MM-DDTHH:mm:ss")

        }
        console.log("material", this.state.Material);
        let url = `${API.putPendingTask}`;
        axios
          .put(url, data)
          .then((response) => {
            // dispatch(getPendingTask(shipDetail.shipId, 1));
            dispatch(
              getPendingTaskLineItems(this.state.Material.purchaseOrderId)
            );
            dispatch({ type: "ShowStaffPendingTaskPanel", data: false });
            history.goBack();
            dispatch({
              type: "putPendingTaskSuccess",
              data: response.data,
            });
            toast.success("Task updated successfully.", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          })
          .catch((error) => {
            dispatch({
              type: "putPendingTaskFailure",
              error: "ERROR",
            });
          });
      } else {
        let url = `${API.bulkUpdatePendingTask}`;
        let bulkMaterial = {
          shipId: this.state.Material.shipId,
          purchaseOrderId: this.state.Material.purchaseOrderId,
          locationUsed: this.state.Material.locationUsed,
          locationRemoved: this.state.Material.locationRemoved,
          quantityUsed: this.state.Material.quantityUsed,
          quantityRemoved: this.state.Material.quantityRemoved,
          attachmentName: this.state.Material.attachmentName,
          attachmentGuid: this.state.Material.attachmentGuid,
          comments: this.state.Material.comments,
          designatedPersonRank: this.state.Material.designatedPersonRank,
          designatedPersonName: this.state.Material.designatedPersonName,
          modifiedBy: "",
          equipment:this.state.Material.equipment,
          deck:this.state.Material.deck,
          installationDate:moment(this.state.Material.installationDate).format("YYYY-MM-DDTHH:mm:ss")

        };
        console.log("bulkMaterial", bulkMaterial);
        axios
          .put(url, bulkMaterial)
          .then((response) => {
            dispatch(getPendingTask(shipDetail.shipId, 1));
            dispatch({ type: "ShowStaffPendingTaskPanel", data: false });
            history.push("/Home/Ship/Staff/Tasks");
            dispatch({
              type: "putBulkPendingTaskSuccess",
              data: response.data,
            });
            toast.success("Bulk Task updated successfully.", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          })
          .catch((error) => {
            dispatch({
              type: "putBulkPendingTaskFailure",
              error: "ERROR",
            });
          });
      }
    }
    else {
      // let warningMsg = "";
      // warning.map((i, index) => {
      //   if (warning.length === 1) {
      //     warningMsg = i;
      //   } else if (warning.length - 1 === index) {
      //     warningMsg = warningMsg + " and " + i;
      //   } else {
      //     warningMsg = warningMsg ? warningMsg + "," + i : i;
      //   }
      // });
      swal("Error!", "Fill all mandatory fields", "warning");
    }
  }

  render() {
    const { TaskDetails, EditAllPO } = this.props;
    return (
      <div className="row" style={{ paddingBottom: "195px" }}>
        <div className="full-height pt-3">
          <div className="grey-bg  course-list-page">
            <div className="panel-box  search-filter-box mb-4">
              <button
                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                onClick={() => this.hideSidePanel()}
              >
                &larr; Return
              </button>
              <div className="resource-list-auth-date">
                <div
                  className="card mt-2 MM-card-header"
                  style={{ backgroundColor: "white" }}
                >
                  <div className="card-body">
                    <h5
                      className="card-title ml-2 mt-2"
                      style={{ color: "092a51" }}
                    >
                      Update Hazardous Material Inventory
                    </h5>
                  </div>
                  <div className="search-filter-box">
                    <div className="row">
                      {!EditAllPO ? (
                        <div className="col-lg-12">
                          <label className="form-label">
                            Item Description :
                          </label>
                          <span>
                            {" "}
                            {TaskDetails.itemDescription
                              ? TaskDetails.itemDescription
                              : ""}
                          </span>
                        </div>
                      ) : null}
                      <div className="col-lg-6">
                        <label className="form-label">PO No :</label>
                        <span> {TaskDetails.poNo ? TaskDetails.poNo : ""}</span>
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label">PR No :</label>
                        <span> {TaskDetails.prNo ? TaskDetails.prNo : ""}</span>
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label">PO Date :</label>
                        <span>
                          {" "}
                          {Moment(
                            new Date(
                              Date.parse(
                                TaskDetails.poDate ? TaskDetails.poDate : ""
                              )
                            )
                          ).format("DD MMM YYYY")}
                        </span>
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label">Quantity :</label>
                        <span>
                          {" "}
                          {TaskDetails.quantity ? TaskDetails.quantity : ""}
                        </span>
                      </div>
                      {!EditAllPO ? (
                        <>
                          <div className="col-lg-6">
                            <label className="form-label">Unit :</label>
                            <span>
                              {" "}
                              {TaskDetails.units ? TaskDetails.units : ""}
                            </span>
                          </div>
                          <div className="col-lg-6">
                            <label className="form-label">SDoC :</label>
                            <span>
                              {" "}
                              {TaskDetails.sDocAttachmentName
                                ? TaskDetails.sDocAttachmentName
                                : ""}
                            </span>
                            {TaskDetails.sDocAttachmentName ? (
                              <i
                                class="fa fa-download click ml-1"
                                onClick={() =>
                                  this.downloadAttachment(
                                    TaskDetails.sDocAttachmentName,
                                    TaskDetails.sDocAttachmentGuid
                                  )
                                }
                              ></i>
                            ) : null}
                          </div>
                          <div className="col-lg-6">
                            <label className="form-label">MD :</label>
                            <span>
                              {" "}
                              {TaskDetails.mdAttachmentName
                                ? TaskDetails.mdAttachmentName
                                : ""}
                            </span>
                            {TaskDetails.mdAttachmentName ? (
                              <i
                                class="fa fa-download click ml-1"
                                onClick={() =>
                                  this.downloadAttachment(
                                    TaskDetails.mdAttachmentName,
                                    TaskDetails.mdAttachmentGuid
                                  )
                                }
                              ></i>
                            ) : null}
                          </div>
                        </>
                      ) : null}
                      <div className="col-lg-12">
                        <label className="form-label">Ship Name :</label>
                        <span>
                          {" "}
                          {TaskDetails.vesselName ? TaskDetails.vesselName : ""}
                        </span>
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label required">Location Used</label>
                        <br></br>
                        <input
                          type="text"
                          className="form-control"
                          name="locationUsed"
                          value={this.state.Material.locationUsed}
                          onChange={(e) => this.handleInputChange(e)}
                        ></input>
                        {this.state.valueError && this.state.Material.locationUsed.trim() == "" &&
                          <span className="spanErrMsg">Location used is required</span>
                        }
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label required">Qty Used</label>
                        <br></br>
                        <input
                          type="text"
                          className="form-control"
                          name="quantityUsed"
                          value={this.state.Material.quantityUsed}
                          onChange={(e) => this.handleInputChange(e)}
                        ></input>
                        {this.state.valueError && this.state.Material.quantityUsed.trim() == "" &&
                          <span className="spanErrMsg">Qty used is required</span>
                        }
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label required">Location Removed</label>
                        <br></br>
                        <input
                          type="text"
                          className="form-control"
                          name="locationRemoved"
                          value={this.state.Material.locationRemoved}
                          onChange={(e) => this.handleInputChange(e)}
                        ></input>
                        {this.state.valueError && this.state.Material.locationRemoved.trim() == "" &&
                          <span className="spanErrMsg">Location removed is required</span>
                        }
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label required">Qty Removed</label>
                        <br></br>
                        <input
                          type="text"
                          className="form-control"
                          name="quantityRemoved"
                          value={this.state.Material.quantityRemoved}
                          onChange={(e) => this.handleInputChange(e)}
                        ></input>
                        {this.state.valueError && this.state.Material.quantityRemoved.trim() == "" &&
                          <span className="spanErrMsg">Qty removed is required</span>
                        }
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label required">Equipment</label>
                        <br></br>
                        <input
                          type="text"
                          className="form-control"
                          name="equipment"
                          value={this.state.Material.equipment}
                          onChange={(e) => this.handleInputChange(e)}
                        ></input>
                        {this.state.valueError && this.state.Material.equipment.trim() == "" &&
                          <span className="spanErrMsg">Equipment is required</span>
                        }
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label required">Deck</label>
                        <br></br>
                        <input
                          type="text"
                          className="form-control"
                          name="deck"
                          value={this.state.Material.deck}
                          onChange={(e) => this.handleInputChange(e)}
                        ></input>
                        {this.state.valueError && this.state.Material.deck.trim() == "" &&
                          <span className="spanErrMsg">Deck is required</span>
                        }
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label required">Installation Date</label>
                        <br></br>
                        <div
                          className="input-group add-on date datepicker"
                          data-date-format="yyyy-mm-dd"
                        >
                          <input
                            type="text"
                            value={this.state.Material.installationDate}
                            className="form-control date-picker"
                            name="installationDate"
                          ></input>
                          <DatePicker
                            selected={this.state.Material.installationDate ? new Date(this.state.Material.installationDate) : ''}
                            onChange={(date) => this.handleInputChangeDate(date)}
                            open={this.state.isDateOpen}
                            onClickOutside={() => { this.setState({ isDateOpen: false }) }}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            popperPlacement="top-end"
                            showTimeInput
                            dateFormat="yyyy-MM-dd h:mm aa"
                            className="form-control date-picker w-5 hide-date"
                          />
                          <div
                            className="input-group-btn calendar-icon"
                            onClick={() => { this.setState({ isDateOpen: !this.state.isDateOpen }) }}
                          >
                            <button className="btn btn-default">
                              <i className="fa fa-calendar mt-1"></i>
                            </button>
                          </div>
                        </div>
                        {this.state.valueError && this.state.Material.installationDate.trim() == "" &&
                          <span className="spanErrMsg">Installation date is required</span>
                        }
                      </div>
                      <div className="col-lg-12 mb-3">
                        <label className="form-label"></label>
                        <br></br>
                        {/* <div class="input-group mb-3">
                          <div class="input-group-prepend">
                            <span class="input-group-text">
                              Choose file
                              <input
                                type="file"
                                id="files"
                                name="attachment"
                                onChange={(e) => this.handleInputChange(e)}
                                onClick={(event) => {
                                  event.currentTarget.value = null;
                                }}
                              />
                            </span>
                          </div>
                          <input
                            type="text"
                            class="form-control"
                            placeholder="No file chosen"
                            value={this.state.attachment}
                          />
                          {this.state.attachment ? (
                            <div class="input-group-append cursor-pointer" onClick={() => this.ClearInput()}>
                              <i
                                class="fa fa-times input-group-text"
                                aria-hidden="true"
                                
                              ></i>
                            </div>
                          ) : null}
                        </div> */}
                        <div className="input-group ">
                          <div className="input-group-prepend">
                            <button
                              type="button"
                              className="btn input-group-text"
                              onClick={() => document.getElementById("files").click()}
                            >
                              Choose file
                            </button>
                          </div>

                          <input
                            type="file"
                            id="files"
                            name="attachment"
                            style={{ display: "none" }}
                            onChange={(e) => this.handleInputChange(e)}
                            onClick={(e) => { e.currentTarget.value = null; }}
                          />

                          <input
                            type="text"
                            className="form-control"
                            placeholder="No file chosen"
                            value={this.state.attachment}
                          />

                          {this.state.attachment && (
                            <div className="input-group-append cursor-pointer" onClick={() => this.ClearInput()}>
                              <span className="input-group-text">
                                <i className="fa fa-times" aria-hidden="true"></i>
                              </span>
                            </div>
                          )}
                        </div>
                        {/* {this.state.valueError && this.state.attachment == "" &&
                          <span className="spanErrMsg">Attachment is required</span>
                        } */}


                      </div>
                      <div className="col-lg-6">
                        <label className="form-label required">
                          Designated Person Rank
                        </label>
                        <br></br>
                        <input
                          type="text"
                          className="form-control"
                          name="designatedPersonRank"
                          value={this.state.Material.designatedPersonRank}
                          onChange={(e) => this.handleInputChange(e)}
                        ></input>
                        {this.state.valueError && this.state.Material.designatedPersonRank.trim() == "" &&
                          <span className="spanErrMsg">Designated person rank is required</span>
                        }
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label required">
                          Designated Person Name
                        </label>
                        <br></br>
                        <input
                          type="text"
                          className="form-control"
                          name="designatedPersonName"
                          value={this.state.Material.designatedPersonName}
                          onChange={(e) => this.handleInputChange(e)}
                        ></input>
                        {this.state.valueError && this.state.Material.designatedPersonName.trim() == "" &&
                          <span className="spanErrMsg">Designated person name is required</span>
                        }
                      </div>
                      <div className="col-lg-12">
                        <label className="form-label">Comments</label>
                        <br></br>
                        <textarea
                          className="form-control"
                          name="comments"
                          value={this.state.Material.comments}
                          onChange={(e) => this.handleInputChange(e)}
                        ></textarea>
                      </div>
                    </div>
                    <div className="row">
                      <div className={"col-lg-12 mt-2 mb-2"}>
                        <label className="form-label"></label>
                        <br></br>
                        <div
                          className="form-group search-btn-col"
                          style={{ textAlign: "end" }}
                        >
                          <button
                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                            type="submit"
                            onClick={() => this.UpdateMaterial()}
                          >
                            Update{" "}
                          </button>

                          <button
                            className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                            type="button"
                            onClick={() => this.hideSidePanel()}
                          >
                            Cancel{" "}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  downloadAttachment = (FileName, Guid) => {
    const { dispatch } = this.props;
    dispatch(DownloadDocument(FileName, Guid));
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    TaskDetails: state.ShipViewReducer.TaskDetails,
    attachmentDetail: state.ShipViewReducer.attachmentDetail,
    shipDetail: state.ShipViewReducer.ShipDetail,
    EditAllPO: state.ShipViewReducer.EditAllPO,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(StaffPOUpdate);
